export default __webpack_public_path__ + "static/hasura-powered-logo-dfebb596de2af0ddeca94c5c906b368b.svg";